import { motion } from "framer-motion";
import { Button } from "../ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQS = [
  {
    q: "Adakah saya perlu membeli tiket untuk hadir?",
    a: "Tidak. Tiada bayaran tiket event. Kelayakan seating berdasarkan deposit ke dalam akaun trading broker anda.",
  },
  {
    q: "Adakah deposit dibayar kepada Fira Worldwide?",
    a: "Tidak. Deposit dimasukkan ke akaun trading broker anda sendiri, tertakluk kepada prosedur broker.",
  },
  {
    q: "Bolehkah saya memilih kategori seating?",
    a: "Ya. DIAMOND, GOLD dan SILVER tersedia mengikut jumlah deposit yang layak serta ketersediaan seat.",
  },
  {
    q: "Bagaimana saya nak confirm seat?",
    a: "Klik butang pendaftaran dan hubungi admin rasmi untuk panduan deposit dan pengesahan.",
  },
  {
    q: "Siapa yang boleh hadir?",
    a: "Event ini dikhaskan untuk existing Fira VIP yang memenuhi syarat pendaftaran.",
  },
  {
    q: "Adakah dinner disediakan untuk semua kategori?",
    a: "Hanya Hi-tea sahaja yang akan disediakan sebelum event untuk peserta.",
  },
];

export const FinalCta = ({ onReserve }) => (
  <section id="faq" data-testid="final-cta-section" className="relative overflow-hidden py-24 md:py-32">
    <div className="pointer-events-none absolute -top-24 left-1/2 h-72 w-[42rem] -translate-x-1/2 rounded-full bg-fira-pink/15 blur-3xl" />
    <div className="relative z-10 mx-auto max-w-4xl px-5">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="text-center"
      >
        <h2 className="font-display text-4xl font-semibold leading-tight md:text-5xl">
          This Is Our Journey. <span className="italic text-fira-rose">This Is Our Next Chapter.</span>
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-4 text-sm leading-relaxed text-white/70 md:text-base">
          <p>Daripada sebuah komuniti trading kepada sebuah keluarga yang terus berkembang.</p>
          <p>The New Era bukan sekadar tentang apa yang bakal datang. Ia juga tentang menghargai mereka yang telah bersama kita sehingga hari ini.</p>
          <p className="font-display text-lg italic text-white">
            Don't just hear about The New Era. Be part of it.
          </p>
        </div>
        <Button
          onClick={onReserve}
          data-testid="final-cta-btn"
          className="btn-lux mt-10 rounded-full px-12 py-6 text-base font-bold tracking-widest text-white transition-all duration-300 hover:scale-105"
        >
          SECURE MY SEAT
        </Button>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="mt-24"
      >
        <h3 className="text-center text-sm font-bold uppercase tracking-[0.3em] text-white">
          Frequently Asked Questions
        </h3>
        <Accordion
          type="single"
          collapsible
          className="mx-auto mt-10 max-w-3xl"
          data-testid="faq-accordion"
        >
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border-white/10"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                className="text-left text-sm font-semibold text-white hover:text-fira-rose md:text-base"
                data-testid={`faq-question-${i}`}
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent
                className="text-sm leading-relaxed text-white/60"
                data-testid={`faq-answer-${i}`}
              >
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);
